/**
 * Integration & Listing Type Definitions.
 */

export interface Integration {
  id: string;
  organization_id: string;
  platform: string;
  name: string;
  settings: Record<string, unknown>;
  is_active: boolean;
  has_credentials: boolean;
  last_sync_at: string | null;
  created_at: string;
  updated_at: string;
}

export interface IntegrationCreate {
  platform: string;
  name: string;
  credentials?: Record<string, string>;
  settings?: Record<string, unknown>;
}

export interface Listing {
  id: string;
  asset_id: string;
  integration_id: string;
  platform: string;
  external_listing_id: string | null;
  listing_url: string | null;
  status: string;
  listed_at: string;
  updated_at: string;
}

export interface ListAssetRequest {
  integration_id: string;
  sale_price?: number;
  title_override?: string;
  description_override?: string;
}

export const PLATFORMS = [
  { value: "shopify", label: "Shopify", color: "#96BF48" },
  { value: "ebay", label: "eBay", color: "#E53238" },
] as const;
